import { WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";
import { GradingReportingModel } from "./grade-reporting.model";

export class GradeReportingDto {
    @ApiProperty()
    @IsNotEmpty({message:"Shift should not be empty"})
    shift: string;
    @ApiProperty()
    @IsNotEmpty({message:"Plant should not be empty"})
    plantId: number;
    @ApiProperty()
    @IsNotEmpty({message:"Lot Number should not be empty"})
    lotNo: string;
    @ApiProperty({
        enum:WorkStationTypeEnum,
        default:WorkStationTypeEnum.INTERNAL
    })
    @IsNotEmpty({message:"Workstation Type should not be empty"})
    workstationType: WorkStationTypeEnum;
    @ApiProperty()
    @IsNotEmpty({message:"Workstation should not be empty"})
    workstation: number;
    @ApiProperty({ type: [GradingReportingModel]})
    @IsNotEmpty({message:"grades should not be empty"})
    grades: GradingReportingModel[];
    @ApiProperty()
    @IsNotEmpty({message:"SO number should not be empty"})
    soNumber: string;
    @ApiProperty()
    @IsNotEmpty({message:"Created user should not be empty"})
    createdUser: string;
    @ApiProperty()
    @IsNotEmpty({message:"main plant not be empty"})
    mainPlantId: number;
}